// frontend/src/tour/steps/saved-routes.steps.js
export const SAVED_ROUTES_TOUR_STEPS = (role, { skipMapStep = false } = {}) => {
  // Normalize role name
  const normalizedRole = normalizeRole(role);

  const steps = [
    {
      id: "saved-routes-welcome",
      selector: "body",
      placement: "center",
      copy: {
        Admin: {
          title: "Welcome to Saved Routes",
          content:
            "Here you can view and manage all your saved routes. Click 'View' on any route to see it displayed on the map with all its stops. You can optimize routes, update lead statuses, and delete routes you no longer need.",
        },
        Manager: {
          title: "Welcome to Saved Routes",
          content:
            "View and manage all your saved routes. Click 'View' on any route to see it on the map and edit its stops. This helps you plan efficient daily routes and reuse successful routes.",
        },
        "Sales Rep": {
          title: "Welcome to Saved Routes",
          content:
            "Access all your saved routes here. Click 'View' on a route to view it on the map and see all the stops. You can optimize routes and update lead statuses as you work.",
        },
      },
    },
    {
      id: "routes-list",
      selector: '[data-tour="routes-list"]',
      placement: "bottom",
      copy: {
        Admin: {
          title: "Saved Routes List",
          content:
            "This table shows all your saved routes with their names, dates, and number of stops. Click 'View' to see a route on the map, or 'Delete' to remove a route you no longer need.",
        },
        Manager: {
          title: "Saved Routes List",
          content:
            "All your saved routes are listed here. Use the 'View' button to see a route on the map, or 'Delete' to remove routes that are no longer useful.",
        },
        "Sales Rep": {
          title: "Your Saved Routes",
          content:
            "See all your saved routes here. Click 'View' to display a route on the map with all its stops. Use 'Delete' to remove routes you don't need anymore.",
        },
      },
    },
    {
      id: "saved-routes-map",
      selector: '[data-tour="saved-routes-map"]',
      placement: "top",
      copy: {
        Admin: {
          title: "Route Map",
          content:
            "The map shows your route path and numbered stops. Use it alongside the stops breakdown to review coverage and stop order.",
        },
        Manager: {
          title: "Route Map",
          content:
            "View the full route on the map with numbered pins. Pair this with the stops list to plan and adjust your day.",
        },
        "Sales Rep": {
          title: "Route Map",
          content:
            "Your route appears here with numbered stops. Use the stops breakdown below to navigate and update statuses as you work.",
        },
      },
    },
    {
      id: "back-to-map",
      selector: '[data-tour="back-to-map"]',
      placement: "left",
      copy: {
        Admin: {
          title: "Back to Lead Map",
          content:
            "Click this button to return to the main Lead Map where you can create new routes, view all leads, and build routes from scratch.",
        },
        Manager: {
          title: "Back to Lead Map",
          content:
            "Return to the main Lead Map to create new routes, see all leads, and plan your territory coverage.",
        },
        "Sales Rep": {
          title: "Back to Map",
          content:
            "Go back to the main Lead Map to create new routes, view all your leads, and build routes by clicking on lead pins.",
        },
      },
    },
  ];

  const visibleSteps = skipMapStep
    ? steps.filter((step) => step.id !== "saved-routes-map")
    : steps;

  // Resolve steps based on role
  return visibleSteps.map((step) => {
    const roleCopy = step.copy[normalizedRole] || step.copy["Sales Rep"];

    return {
      selector: step.selector,
      placement: step.placement,
      title: roleCopy.title,
      content: roleCopy.content,
    };
  });
};

// Helper function to normalize role names
function normalizeRole(role) {
  if (!role) return "Sales Rep";
  const roleLower = role.toLowerCase();
  if (roleLower.includes("admin")) return "Admin";
  if (roleLower.includes("director")) return "Admin"; // Sales Director uses Admin copy
  if (roleLower.includes("manager")) return "Manager";
  return "Sales Rep";
}
